module.exports = __webpack_public_path__ + "static/media/securityguard2.a3e492b3.png";